import {saveAs} from 'file-saver';

export const XLS = '.xls';
export const XLSX = '.xlsx';
export const PDF = '.pdf';
export const XML = '.xml';
export const CSV = '.csv';
export const ZIP = '.zip';

export class FileUtils {

  public static generateImgUrl(imageBlob: Blob | string | number[]): string {
    const blob = imageBlob != null ? this.toImageBlob(imageBlob) : null;
    return blob != null ? URL.createObjectURL(blob) : null;
  }

  private static toImageBlob(blob: Blob | string | number[]): Blob {
    if (blob instanceof Blob) {
      return blob.type === 'application/json'
        ? blob.slice(0, blob.size, 'image/svg+xml')
        : blob;
    }
    if (Array.isArray(blob)) {
      const bytes = new Uint8Array(blob);
      return new Blob([bytes], {type: this.logoMime(bytes)});
    }
    if (typeof blob === 'string' && blob.trim().startsWith('<')) {
      return new Blob([blob], {type: 'image/svg+xml'});
    }
    if (typeof blob === 'string') {
      try {
        const binary = atob(blob.replace(/\s/g, ''));
        const bytes = new Uint8Array(binary.length);
        for (let i = 0; i < binary.length; i++) {
          bytes[i] = binary.charCodeAt(i);
        }
        return new Blob([bytes], {type: this.logoMime(bytes)});
      } catch (e) {
        return null;
      }
    }
    return null;
  }

  private static logoMime(bytes: Uint8Array): string {
    if (bytes[0] === 0x3C) {
      return 'image/svg+xml';
    }
    if (bytes[0] === 0x89) {
      return 'image/png';
    }
    return 'image/jpeg';
  }

  public static saveFile(theBlob: Blob, fileName: string, suffix?: string): void {
    suffix == null
      ? saveAs(theBlob, fileName)
      : this.saveWithSuffix(theBlob, fileName, suffix);
  }

  private static saveWithSuffix(theBlob: Blob, filePrefix: string, suffix: string): void {
    let name = this.removeSpaces(filePrefix);
    suffix !== PDF
      ? saveAs(theBlob, name + suffix)
      : saveAs(this.toPdf(theBlob, name), name + PDF);
  }

  public static removeSpaces(fileName: string): string {
    return fileName.replace(/ /g, '_');
  }

  private static toPdf(theBlob: Blob, fileName: string): File {
    return new File(
      [theBlob as any],
      fileName,
      {
        lastModified: new Date().getTime(),
        type: 'pdf'
      }
    );
  }

}
